import {isLoggedIn} from './utils';
import {redirectAfterRegistration} from "./session";

if (isLoggedIn()) {
  redirectAfterRegistration();
}